import { Button, ChevronDownSVG, ChevronUpSVG } from "@newsela/angelou";

import {
  withTrackEvent,
  objectTypes,
  actionNames,
  actionPrefixes,
} from "@newsela/snitch";
import { unstyledHeadingsCss } from "@/components/components.style";
import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";
import {
  formatResultCountMessage,
  getTotalResultCount,
} from "@/search/Langston/SearchPageProvider/SearchPageProvider.utils";
import { LangstonParameterSchema } from "../../LangstonParameterSchema";
import { VisibilityPermissions } from "../VisibilityPermissions";
import {
  buttonCss,
  filterAndSortVisibilityCss,
  filterHeaderContainerCss,
  needleCss,
  totalResultsCss,
} from "./FilterHeader.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

const eventProperties = {
  objectType: objectTypes.content,
  actionPrefix: actionPrefixes.initiate,
  actionName: actionNames.filter,
  streamProperties: {
    description: "Open or close the search filter panel on smaller screens",
  },
};

export const FilterHeader = ({
  isFilterPanelOpen,
  setIsFilterPanelOpen,
}: IFilterHeader) => {
  const {
    getters: { isDisabledFilters, searchResponse, isSearchLoading },
    handlers: { getSearchParamValues },
  } = useSearchPageContext();

  const needleValue = getSearchParamValues(
    LangstonParameterSchema.needle.key,
  )?.[0];
  const totalResultCount = getTotalResultCount(
    isDisabledFilters,
    searchResponse?.total_result_count,
  );

  return (
    <div css={filterHeaderContainerCss}>
      <div css={totalResultsCss}>
        <h1 css={unstyledHeadingsCss}>
          {isSearchLoading
            ? "Loading results..."
            : formatResultCountMessage(totalResultCount)}
          {needleValue && (
            <span>
              &nbsp;for <span css={needleCss}>{`"${needleValue}"`}</span>
            </span>
          )}
        </h1>
        <span>{isSearchLoading && "..."}</span>
        <div css={filterAndSortVisibilityCss}>
          <ButtonWithTrackEvent
            __cssFor={buttonCss}
            flavor={Button.flavors.primary}
            onClick={() => setIsFilterPanelOpen(!isFilterPanelOpen)}
            icon={{
              SvgComponent: isFilterPanelOpen ? ChevronUpSVG : ChevronDownSVG,
              alignment: Button.iconAlignments.right,
            }}
            dataProps={{
              "data-testid": isFilterPanelOpen
                ? "chevron-up-icon"
                : "chevron-down-icon",
            }}
            {...eventProperties}
          >
            Filter and sort
          </ButtonWithTrackEvent>
        </div>
      </div>

      <VisibilityPermissions />
    </div>
  );
};

interface IFilterHeader {
  isFilterPanelOpen: boolean;
  setIsFilterPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
